export default __webpack_public_path__ + "static/36-7c25563ff702d60b45464875c36cc302.png";